// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2-BuYAKqK4GrrfoIgXN7YK"};